import { useCallback, useEffect, useState } from "react";
import { api, unwrap } from "@/lib/api";

export function useShifts({ branchId, start, end } = {}) {
  const [shifts, setShifts] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetch = useCallback(async () => {
    try {
      const params = {};
      if (branchId) params.branch_id = branchId;
      if (start) params.start = start;
      if (end) params.end = end;
      const r = await api.get("/shifts", { params });
      setShifts(unwrap(r) || []);
    } catch {} finally { setLoading(false); }
  }, [branchId, start, end]);

  useEffect(() => { fetch(); }, [fetch]);

  const create = async (payload) => { await api.post("/shifts", payload); await fetch(); };
  const update = async (id, patch) => { await api.patch(`/shifts/${id}`, patch); await fetch(); };
  const remove = async (id) => { await api.delete(`/shifts/${id}`); await fetch(); };

  return { shifts, loading, refresh: fetch, create, update, remove };
}
